module.exports = __webpack_public_path__ + "static/media/DSC_2898.dec61d34.jpg";